import {Component} from 'react'
import {v4 as uuidv4} from 'uuid'
import CharacterCount from '../CharacterCount'
import './index.css'

class CharacterInput extends Component {
  state = {
    text: '',
    characterList: [],
  }

  handleChange = e => {
    this.setState({text: e.target.value})
  }

  onClickSubmit = event => {
    event.preventDefault()
    const {text} = this.state
    const name = text.trim()
    if (!name) return

    const newItem = {id: uuidv4(), name}

    this.setState(prev => ({
      characterList: [...prev.characterList, newItem],
      text: '',
    }))
  }

  render() {
    const {characterList, text} = this.state // ✅ FIXED — added `text`

    return (
      <div className="main-container">
        <CharacterCount characterList={characterList} />

        <div className="right-panel">
          <h2 className="rp-heading">Character Counter</h2>

          <form className="rp-form" onSubmit={this.onClickSubmit}>
            <input
              type="text"
              className="rp-input"
              placeholder="Enter the Characters here"
              value={text} // ← works now
              onChange={this.handleChange}
              aria-label="Enter characters"
            />
            <button type="submit" className="rp-add-btn">
              Add
            </button>
          </form>
        </div>
      </div>
    )
  }
}

export default CharacterInput
